module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1180.824836e2.png";